import { css } from "@emotion/react";

export default {
  container: css`
    width: 100%;
  `,
};
